export const GEISINGER_AUTH_CONNECTION = 'geisinger';

type AuthEnvironment = {
  isLocalDevelopment: boolean;
  hostname: string;
};

const getAuthEnvironment = (): AuthEnvironment => ({
  isLocalDevelopment: import.meta.env.DEV,
  hostname: window.location.hostname,
});

const AUTH_SELECTOR_PARAMETERS = ['login', 'connection'];

export const getAuthSelectorSearch = (search: string): string => {
  const parameters = new URLSearchParams(search);
  const selectors = new URLSearchParams();
  AUTH_SELECTOR_PARAMETERS.forEach((name) => {
    const value = parameters.get(name);
    if (value !== null) selectors.set(name, value);
  });
  return selectors.toString();
};

export const hasExplicitAuthSelector = (search: string): boolean => {
  const parameters = new URLSearchParams(search);
  return parameters.get('login') === 'dev' || parameters.has('connection');
};

export const isDevelopmentAuthEnvironment = (
  { isLocalDevelopment, hostname }: AuthEnvironment = getAuthEnvironment(),
): boolean => isLocalDevelopment || hostname === 'dev.geisinger.league.dev';

export const getAuthConnection = (
  search: string,
  environment: AuthEnvironment = getAuthEnvironment(),
): string | undefined => {
  if (!isDevelopmentAuthEnvironment(environment))
    return GEISINGER_AUTH_CONNECTION;

  const parameters = new URLSearchParams(search);
  if (parameters.get('login') === 'dev') return undefined;

  const connection = parameters.get('connection');
  // Explicit undefined overrides the SDK's configured customer connection,
  // restoring the existing Auth0 login screen for developer accounts.
  if (connection === 'default') return undefined;
  return connection || GEISINGER_AUTH_CONNECTION;
};
